import Checkmark from "@/app/assets/images/svg/tick.svg";
import * as Checkbox from "@radix-ui/react-checkbox";
import clsx from "clsx";
import {
	InputHTMLAttributes,
	ReactNode,
	forwardRef,
	useId,
	useRef,
} from "react";
import styles from "./Checkbox.module.scss";

interface Props extends InputHTMLAttributes<object> {
	label: ReactNode;
	checked?: boolean;
	defaultChecked?: boolean;
	errorMessage?: string;
	disabled?: boolean;
}

const CheckboxInput = forwardRef<HTMLButtonElement, Props>((props, ref) => {
	const {
		label,
		defaultChecked = false,
		errorMessage = false,
		disabled = false,
		checked,
		...rest
	} = props;

	const inputRef = useRef<HTMLInputElement>(null);

	const id = useId();

	const handleOnClick = () => {
		inputRef?.current?.click();
	};

	return (
		<div
			className={clsx([styles.container, disabled ? styles.disabled : null])}
		>
			<input
				ref={inputRef}
				type='checkbox'
				id={props.id}
				checked={checked || defaultChecked}
				onChange={(e) => {
					props.onChange?.(e);
				}}
				{...rest}
			/>
			<Checkbox.Root
				id={`checkbox-${id}`}
				className={styles.checkbox}
				disabled={disabled}
				ref={ref}
				checked={checked}
				defaultChecked={defaultChecked}
				onClick={handleOnClick}
			>
				<Checkbox.Indicator className={styles.checked}>
					<Checkmark className={styles.checkmark} />
				</Checkbox.Indicator>
			</Checkbox.Root>
			<label className={styles.label} htmlFor={`checkbox-${id}`}>
				{label}
			</label>
		</div>
	);
});

export default CheckboxInput;
